import React from 'react';

export const VideoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
    >
      <path
        d="M0 4C0 2.90625 0.875 2 2 2H10C11.0938 2 12 2.90625 12 4V12C12 13.125 11.0938 14 10 14H2C0.875 14 0 13.125 0 12V4ZM17.4688 3.125C17.7812 3.3125 18 3.65625 18 4V12C18 12.375 17.7812 12.7188 17.4688 12.9062C17.125 13.0625 16.75 13.0625 16.4375 12.8438L13.4375 10.8438L13 10.5625V10V6V5.46875L13.4375 5.1875L16.4375 3.1875C16.75 2.96875 17.125 2.96875 17.4688 3.125Z"
        fill="currentColor"
      />
    </svg>
  );
};
